import React, { FC, useEffect, useState } from "react";
import { Input, Button, Modal, Row, Col, Spin } from "antd";
import _ from "lodash";

import ReactPlayer from "react-player";

const VideoPlayerModal: FC<{ onClose?: () => void; url?: string }> = ({
  onClose,
  url,
}) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);

  const handleCancel = () => {
    console.log("close", url);
    setIsModalVisible(false);
    onClose && onClose();
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      title="Video player"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="760px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <ReactPlayer controls={true} url={url} />
    </Modal>
  );
};

export default VideoPlayerModal;
